import joinClasses from "helpers/joinClasses";

export function ThinHorizontalLine({ className = "", ...props }) {
  return (
    <div
      className={joinClasses(
        className,
        "border-[0.5px] border-grey-disabled rounded-full w-full m-auto w-auto"
      )}
      {...props}
    ></div>
  );
}
